// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AFI3","colMin":"styles_colMin__1lkmJ"};